import React, { Component } from 'react';
import { connect } from 'react-redux';
import { /*PieChart,*/ Settings, User } from 'react-feather';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { createStructuredSelector } from 'reselect';
import { NavLink } from 'react-router-dom';

import { makeSelectUser } from 'containers/App/selectors';
import { userLogout } from 'containers/App/actions';
import { ROLE_USER } from '../../containers/App/constants';

export class UserDropdown extends Component {
  handleSignOut = () => {
    this.props.userLogout();
  };

  render() {
    const { user = {} } = this.props;
    const tokenData = JSON.parse(localStorage.getItem('psaas.token_data')) || {};
    return (
      <UncontrolledDropdown nav inNavbar>
        <span className="d-inline-block d-sm-none">
          <DropdownToggle nav caret>
            <Settings size={18} className="align-middle" />
          </DropdownToggle>
        </span>
        <span className="d-none d-sm-inline-block">
          <DropdownToggle nav caret>
            <img
              src="/images/default-avatar.png"
              className="avatar img-fluid rounded-circle mr-1"
              alt={user.username}
            />
            <span className="text-dark">{user.username || tokenData.email} </span>
          </DropdownToggle>
        </span>
        <DropdownMenu right>
          <DropdownItem>
            <User size={18} className="align-middle mr-2" />
            Profile
          </DropdownItem>
          {/* <DropdownItem>
            <PieChart size={18} className="align-middle mr-2" />
            Analytics
          </DropdownItem> */}
          <DropdownItem divider />
          {/* <DropdownItem>Settings & Privacy</DropdownItem> */}
          {/* stripe - Subscription */}
          <DropdownItem
            tag={NavLink}
            to="/subscription"
            disabled={user.role === ROLE_USER}
            style={user.role === ROLE_USER ? { color: '#bcbcbc' } : {}}
          >
            Subscription
          </DropdownItem>
          {/* stripe - Subscription */}
          <DropdownItem tag="a" href="https://www.parousya.com/contact" target="__blank">
            Help
          </DropdownItem>
          <DropdownItem onClick={this.handleSignOut}>Sign out</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});

const mapDispatchToProps = { userLogout };

export default connect(mapStateToProps, mapDispatchToProps)(UserDropdown);
